import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Select from 'react-select';
import { get, find, isEmpty } from 'lodash';
import displayError from '../../utilities/displayError';

const customStyles = (hasError) => {
  return {
    control: (provided, { isFocused }) => {
      const focusColors = isFocused ? { boxShadow: 0 } : {};

      return {
        ...provided,
        ...focusColors,
        height: 42,
        borderColor: hasError ? '#FB2F3C' : '#DDE0E6'
      };
    },

    placeholder: (provided) => {
      return {
        ...provided,
        color: '#CED2DA'
      };
    },

    option: (provided, { isSelected, isFocused }) => ({
      ...provided,
      backgroundColor: isSelected
        ? '#F8F9FA'
        : isFocused
          ? '#F8F9FA'
          : null,
      color: '#343840',
      padding: 8
    }),

    dropdownIndicator: (provided) => ({
      ...provided,
      color: '#343840'
    }),

    indicatorSeparator: () => ({
      display: 'none'
    }),

    menu: (provided) => ({
      ...provided,
      marginTop: 0,
      boxShadow: 'none',
      border: '1px solid #DDE0E6',
      borderTop: 0
    })
  };
};

const customTheme = (theme) => ({
  ...theme,
  borderRadius: 2,
  colors: {
    ...theme.colors,
    primary: '#DDE0E6',
    primary75: '#E9EBEF',
    primary50: '#E9EBEF',
    primary25: '#E9EBEF'
  }
});

// This is duplicated in shared-components
const SelectField = ({
  className = '',
  inputClassName = '',
  options = [],
  input = {},
  meta = {},
  styles = null,
  placeholder = null,
  errorMessage = null,
  maxMenuHeight = 300,
  id = '',
  attributes = {},
  allOptions = [],
  isDisabled,
  isError = false,
  classNamePrefix
}) => {
  const { error, submitFailed } = meta;
  const selectFieldClassNames = classNames('SelectField', className);
  const { name, value, onChange } = input;
  // This is so that react-select can tie into redux form's methods
  const handleOnChange = (changeValue) => {
    const val = get(changeValue, 'value');
    if (val || 0 === val) {
      onChange(val);
    }
  };
  const reduxFormValue = !isEmpty(allOptions) ?
    find(allOptions, { value })
    :
    find(options, { value });

  const fieldError = isError || !!(error && submitFailed);

  return (
    <div className={selectFieldClassNames} {...attributes}>
      <Select
        name={name}
        value={reduxFormValue || null}
        className={inputClassName}
        placeholder={placeholder}
        options={options}
        onChange={handleOnChange}
        styles={styles || customStyles(fieldError)}
        theme={customTheme}
        isSearchable={false}
        maxMenuHeight={maxMenuHeight}
        inputId={id}
        isDisabled={isDisabled}
        classNamePrefix={classNamePrefix}
      />
      { fieldError &&
        <p className="error text-danger text-small">
          {displayError(errorMessage, error)}
        </p>
      }
    </div>
  );
};

SelectField.propTypes = {
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  options: PropTypes.array,
  input: PropTypes.object,
  meta: PropTypes.object,
  placeholder: PropTypes.string,
  errorMessage: PropTypes.string,
  styles: PropTypes.object,
  id: PropTypes.string,
  removeSelections: PropTypes.bool,
  maxMenuHeight: PropTypes.number,
  attributes: PropTypes.object,
  allOptions: PropTypes.array,
  isDisabled: PropTypes.bool,
  classNamePrefix: PropTypes.string,
  isError: PropTypes.bool
};

export default SelectField;
